import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  gettrusteeAccess,
  getTrustessList,
  trusteeAccess,
  UpdateTrustee,
} from '../../redux-store/actions/userManagement';
import { AddTrusteeRequestBody, Trustee } from '../../redux-store/types/api-types';
import { ColumnType } from '../DataTable';
import { useHistory } from 'react-router';
import UserMgmtListPage, {
  NameLinkCell,
  buildAccessColumn,
  buildActionsColumn,
  formatPhone,
  formatUserName,
  matchesUserSearch,
} from './UserMgmtListPage';

function Trustees(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [accessForEditAdd, setAccessForEditAdd] = useState(false);

  return (
    <UserMgmtListPage<Trustee>
      loadData={async () => {
        const res = (await dispatch(getTrustessList())) as unknown as Trustee[];
        const access = (await dispatch(gettrusteeAccess())) as unknown as trusteeAccess;
        setAccessForEditAdd(access.trusteeAccess);
        return res || [];
      }}
      searchPlaceholder="Search for Trustees"
      inviteLabel="Add Trustee"
      showInvite={accessForEditAdd}
      onInvite={() => history.push('add-trustee')}
      accessDisabled={!accessForEditAdd}
      filterRow={(row, q) =>
        matchesUserSearch(q, [
          formatUserName(row.user),
          row.user?.email,
          `${row.user?.countryCode || ''}${row.user?.phone || ''}`,
        ])
      }
      getColumns={({ onToggleAccess, accessDisabled }) => {
        const columns: ColumnType[] = [
          {
            header: 'Name',
            align: 'left',
            headerAlign: 'left',
            renderCell: (row: Trustee) => (
              <NameLinkCell
                label={formatUserName(row.user)}
                to={{ pathname: 'trustee-details', state: { trusteeId: row.id } }}
              />
            ),
          },
          {
            header: 'Email Id',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: Trustee) => row.user.email || 'N/A',
          },
          {
            header: 'Mobile number',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: Trustee) => formatPhone(row.user),
          },
          buildAccessColumn(onToggleAccess, accessDisabled),
          buildActionsColumn((row: Trustee) => [
            {
              label: 'View Details',
              icon: '/images/view-application.svg',
              to: { pathname: 'trustee-details', state: { trusteeId: row.id } },
            },
            {
              label: 'View Plans',
              icon: '/images/rm.svg',
              to: { pathname: 'trustee-plans', state: { trusteeId: row.id } },
            },
          ]),
        ];
        return columns;
      }}
      onAccessChange={async (row, nextActive) =>
        (await dispatch(
          UpdateTrustee(row.id as number, {
            ...(row as unknown as AddTrusteeRequestBody),
            isActive: nextActive,
          })
        )) as unknown as Trustee
      }
    />
  );
}

export default Trustees;
